import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Nav } from "react-bootstrap";
import "../../../assets/css/Customer/CustomerMyRide/CustomerMyRide.css";
import CustomerMasterLayout from "../../../layouts/Customer/CustomerMasterLayout";
import CustomerRideCard from "../../../components/Customer/CustomerRide/CustomerRideCard";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const CustomerMyRide = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("request");
  const [rides, setRides] = useState([]);

  const { baseUrl, authToken ,setSelectedRideforFindingDriver} = useContext(AppContext);

  const handleCall = (ride) => window.open(`tel:Rs.{ride.driver.phone}`);
  const handleMessage = () => navigate("/customer-chat");
  const handleCancel = (ride) => console.log("Cancel ride:", ride.id);

  const handleCardClick = (ride) => {
    console.log(ride);
     //setSelectedRideforFindingDriver(ride);
     //navigate("/customer-finding-driver");
  };

  const fetchRideDetails = (status) => {
    const customerId = JSON.parse(localStorage.getItem("tdcustomer")).id;
    console.log(customerId);
    const formData = new FormData();
    formData.append("status", status);

    axios
      .post(`${baseUrl}/customer/ride/viewRides`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("Active Rides Response:", response.data);
        if (response.data.success === true) {
          setRides(response.data.rides);
          const authToken = localStorage.getItem("authToken");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  useEffect(() => {
    const tab = location.state?.tab || "request";
    setActiveTab(tab);
    fetchRideDetails(tab);
  }, []);

  return (
    <CustomerMasterLayout screenName={"My Rides"}>
      <div className="customermyride-wrapper">
        <Container className="customermyride-content">
          {/* TABS */}
          <Nav className="customermyride-tabs mt-3">
            {[
              { key: "request", label: "request Ride" },
              { key: "bid_sent", label: "Received Bids" },
              { key: "accept", label: "accept Ride" },
              { key: "ongoing", label: "ongoing Ride" },
              { key: "complete", label: "Complete Ride" },
              { key: "cancel", label: "Cancel Ride" },
            ].map((tab) => (
              <Nav.Item key={tab.key}>
                <Nav.Link
                  onClick={() => {
                    setActiveTab(tab.key);
                    fetchRideDetails(tab.key);
                  }}
                  className={`customermyride-tab ${activeTab === tab.key ? "active" : ""}`}
                >
                  {tab.label}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          {/* RIDES LIST */}
          <div
            className="customermyride-rides-list"
            style={{ overflowY: "scroll" }}
          >
            {/* {getCurrentRides().length > 0 ? ( */}
            {rides.length > 0 ? (
              // getCurrentRides().map((ride) => (
              rides.map((ride) => (
                <CustomerRideCard
                  key={ride.id}
                  rideData={ride}
                  activeTab={activeTab}
                  showCallMessage={
                    activeTab === "active" || activeTab === "pending"
                  }
                  showCancelButton={activeTab === "pending"}
                  onCall={handleCall}
                  onMessage={handleMessage}
                  onCancel={handleCancel}
                  onCardClick={() => handleCardClick(ride)}
                />
              ))
            ) : (
              <div className="customermyride-empty-state">
                <p>No rides found</p>
              </div>
            )}
          </div>
        </Container>
      </div>
    </CustomerMasterLayout>
  );
};

export default CustomerMyRide;
